var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 57.8276C88 70.6368 88 77.0414 83.6652 81.0207C79.3304 85 72.3536 85 58.4 85H43.6C29.6464 85 22.6696 85 18.3348 81.0207C14 77.0414 14 70.6368 14 57.8276C14 45.0185 14 38.6139 18.3348 34.6346C20.7516 32.416 23.9896 31.4344 28.8 31M73.2 31C78.0104 31.4344 81.2484 32.416 83.6652 34.6346C86.0819 36.8531 87.1513 39.8255 87.6245 44.2412",
    stroke: "#001055",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1997 30.7759H57.7997",
    stroke: "#001F55",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6001 40.9761H54.4001",
    stroke: "#001F55",
    strokeOpacity: 0.5,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8001 17.0088C63.6024 17.058 66.8011 17.3801 68.9105 19.4895C71.4001 21.9791 71.4001 25.986 71.4001 33.9999V41.015C71.4001 42.5811 71.4001 43.3642 71.0791 44.0496C70.7581 44.7349 70.1565 45.2362 68.9534 46.2389L66.5066 48.2778M44.2001 17.0088C38.3978 17.058 35.1991 17.3801 33.0897 19.4895C30.6001 21.9791 30.6001 25.986 30.6001 33.9999V41.015C30.6001 42.5811 30.6001 43.3642 30.9211 44.0496C31.2421 44.7349 31.8437 45.2362 33.0468 46.2389L37.9403 50.3168C44.1849 55.5206 47.3072 58.1225 51.0001 58.1225C53.2077 58.1225 55.2114 57.1927 57.8001 55.333",
    stroke: "#001055",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.503d4099ec874dcd6510a4316038be1a.svg";
export { ForwardRef as ReactComponent };